export default __webpack_public_path__ + "static-bigflip/media/ilus-404.70f9bc00.png";